import React from 'react';
import {compose} from 'recompose';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';
import {Button} from '@yandex-data-ui/page-constructor';

import withRouter, {WithRouterProps} from 'hoc/withRouter';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import withPageContext from 'units/constructor-local/hoc/withPageContext';
import {PageContextProps} from 'units/constructor-local/contexts/PageContext';
import {isServiceNeedAccess} from 'units/constructor-local/utils';
import EnterConsoleLink from 'components/EnterConsoleLink/EnterConsoleLink';
import routerInstance from 'router';
import {ModalFormType} from 'units/constructor-local/components/ModalForm/utils';

type PreviewButtonProps = ClassNameProps &
    PageContextProps &
    WithRouterProps &
    WithTranslationProps;

const getServiceFormType = (slug: string) => {
    return slug === 'interconnect' ? ModalFormType.Interconnect : ModalFormType.Preview;
};

const PreviewButton: React.FC<PreviewButtonProps> = (props) => {
    const {
        service,
        className,
        router: {as},
        i18nK,
    } = props;

    if (!service || !isServiceNeedAccess(service)) {
        return (
            <EnterConsoleLink
                context="service"
                size="xl"
                className={className}
                exactLink={service?.consoleUrl || undefined}
                id={service?.slug}
            />
        );
    }

    return (
        <Button
            className={className}
            size="xl"
            theme="action"
            text={i18nK('button_request-access')}
            onClick={() => {
                const [url] = as.split('#');
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (routerInstance as any).replace(`${url}#${getServiceFormType(service.slug)}`);
            }}
        />
    );
};

export default compose<PreviewButtonProps, ClassNameProps>(
    withPageContext,
    withRouter,
    withTranslation(),
)(PreviewButton);
